// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"6819":"aeeb8a956a5d515e","6956":"a3c4fd5625933967"}[chunkId] + ".js";
};